module.exports = __webpack_public_path__ + "hyperion-v2-static/img/control-risks-logo-dark.65208185.png";